import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M40 42.989a3 3 0 0 1-5.103 2.14l-7.283-7.158c-1.148.02-2.296.029-3.444.029-5.045 0-10.157-.186-15.333-.559a7 7 0 0 1-6.47-6.362C2.122 28.324 2 25.31 2 22.036c0-2.64.08-4.955.24-6.946a7 7 0 0 1 6.48-6.423c5.92-.42 11.034-.631 15.345-.631 4.3 0 9.371.21 15.218.628a7 7 0 0 1 6.477 6.422c.16 1.992.24 4.308.24 6.95 0 3.278-.123 6.296-.368 9.055A7 7 0 0 1 40 37.34v5.648Zm-2-6.528a1 1 0 0 1 .928-.998c2.54-.185 4.494-2.109 4.712-4.55.24-2.696.36-5.656.36-8.877 0-2.592-.078-4.856-.233-6.79a5 5 0 0 0-4.627-4.588c-5.802-.415-10.828-.622-15.075-.622-4.259 0-9.327.208-15.202.626a5 5 0 0 0-4.63 4.588C4.078 17.183 4 19.446 4 22.036c0 3.217.12 6.172.36 8.866a5 5 0 0 0 4.62 4.544c5.13.37 10.193.554 15.19.554 1.276 0 2.551-.012 3.827-.036a1 1 0 0 1 .72.287l7.582 7.451A1 1 0 0 0 38 42.99v-6.528ZM14.586 22.586a2 2 0 1 0 2.828 2.828 2 2 0 0 0-2.828-2.828Zm16 2.828a2 2 0 1 1 2.828-2.828 2 2 0 0 1-2.828 2.828Zm-8-2.828a2 2 0 1 0 2.828 2.828 2 2 0 0 0-2.828-2.828Z",
      clipRule: "evenodd"
    }
  )
);
var SvgMessageDotsOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var MessageDotsOutlined_default = SvgMessageDotsOutlined;

export { MessageDotsOutlined_default as default };
